import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Typography, Box, Button
    , Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Add as IconAdd, Delete as IconDelete, Edit as IconEdit } from "@mui/icons-material";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import comprobantePagoService from "../services/comprobantePagoService";
import * as catalogoService from "../services/catalogoService";
import { init, setEntity, setData, setValidationMessage, activeValidations
    , setListMedioPago, setListEntidadPago, nuevoPago } from "../redux/receiptPaymentSlice";
import { FormHelperText as HelperText } from '@mui/material';
import DialogYesNo from './DialogYesNo';

// Detalle de pagos del comprobante. Los pagos son un segundo detalle: pueden
// registrarse junto al comprobante o despues, como pagos parciales.

// Catalogo 1 = Estados del pago del comprobante.
const ESTADO_PAGO = {
    2: "Activo",
    3: "Inactivo",
    4: "Anulado",
    227: "Pago Consolidado",
}

const ReceiptPayment = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const params = useParams();
    const setPayments = props.setPayments;
    const esNuevo = props.esNuevo;

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    const entity = useSelector((state) => state.receiptPayment[sliceKey]?.entity);
    const listMedioPago = useSelector((state) => state.receiptPayment[sliceKey]?.listMedioPago);
    const listEntidadPago = useSelector((state) => state.receiptPayment[sliceKey]?.listEntidadPago);
    const validate = useSelector((state) => state.receiptPayment[sliceKey]?.validationActive);
    // El pago hereda la moneda y el tipo de cambio del comprobante, para no repetirlos.
    const comprobante = useSelector((state) => state.receipt["Normal"]?.entity);

    const [listPayments, setListPayments] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectIndexDelete, setSelectIndexDelete] = useState(-1);

    const validation = {
        idMedioPago: {
            error: entity?.idMedioPago == 0 || entity?.idMedioPago == null,
            message: "Seleccione el medio de pago",
        },
        fechaPago: {
            error: !entity?.fechaPago,
            message: "Ingrese la fecha del pago",
        },
        monto: {
            error: entity?.monto == null || parseFloat(entity?.monto) <= 0,
            message: "Ingrese el monto del pago",
        },
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const fetchListMedioPago = async () => {
        const data = await catalogoService.getCatalogosByPadre(200)
            .catch((err) => { console.log("Err: ", err) });
        dispatch(setListMedioPago({sliceKey: sliceKey, data: data}));
    }
    const fetchListEntidadPago = async () => {
        const data = await catalogoService.getCatalogosByPadre(210)
            .catch((err) => { console.log("Err: ", err) });
        dispatch(setListEntidadPago({sliceKey: sliceKey, data: data}));
    }
    const fetchPayments = useCallback(async () => {
        if (params.id > 0) {
            const pagos = await comprobantePagoService.getsComprobantePagoView(params.id)
                .catch((err) => { console.log("Err: ", err) });

            setListPayments(pagos ?? []);
            if (setPayments) setPayments(pagos ?? []);
        }
    }, [params.id]);

    useEffect(() => {
        fetchListMedioPago();
        fetchListEntidadPago();
        fetchPayments();
    }, [fetchPayments]);

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    // Los pagos que ya estan en la base llegan con IdComprobante; los que se
    // agregan en esta pantalla todavia no lo tienen. Los pagos ya registrados no
    // se editan ni se borran desde aqui, por eso en sus acciones se muestra el
    // estado del pago.
    const esPagoRegistrado = (row) => (row?.idComprobante || 0) > 0 || (row?.id || 0) > 0;

    const estadoPagoDescripcion = (row) => row?.estado || ESTADO_PAGO[row?.idEstado] || "";

    const handleAddPayment = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var newPayment = {
            id: 0,
            numero: listPayments.length + 1,
            idMedioPago: entity.idMedioPago,
            medioPago: entity.medioPago,
            idEntidadPago: entity.idEntidadPago,
            entidadPago: entity.entidadPago,
            numeroCuenta: entity.numeroCuenta,
            numeroOperacion: entity.numeroOperacion,
            numeroVoucher: entity.numeroVoucher,
            fechaPago: entity.fechaPago,
            // Hereda la moneda y el tipo de cambio del comprobante.
            idMoneda: comprobante?.idMoneda || 0,
            moneda: comprobante?.moneda || "",
            tipoCambio: comprobante?.tipoCambio || 1,
            monto: parseFloat(entity.monto) || 0,
            observaciones: entity.observaciones,
            idEstado: 2,
        };

        var newList = [...listPayments, newPayment];
        setListPayments(newList);
        if (setPayments) setPayments(newList);
        dispatch(setEntity({sliceKey: sliceKey, data: nuevoPago()}));
    }

    const handleEditPayment = (index) => {
        if (esPagoRegistrado(listPayments[index])) return;

        setEditingIndex(index);
        dispatch(setEntity({sliceKey: sliceKey, data: listPayments[index]}));
    }

    const handleUpdatePayment = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var updatedPayment = {
            ...listPayments[editingIndex],
            idMedioPago: entity.idMedioPago,
            medioPago: entity.medioPago,
            idEntidadPago: entity.idEntidadPago,
            entidadPago: entity.entidadPago,
            numeroCuenta: entity.numeroCuenta,
            numeroOperacion: entity.numeroOperacion,
            numeroVoucher: entity.numeroVoucher,
            fechaPago: entity.fechaPago,
            idMoneda: comprobante?.idMoneda || listPayments[editingIndex].idMoneda,
            moneda: comprobante?.moneda || listPayments[editingIndex].moneda,
            tipoCambio: comprobante?.tipoCambio || listPayments[editingIndex].tipoCambio,
            monto: parseFloat(entity.monto) || 0,
            observaciones: entity.observaciones,
        };

        var newList = [...listPayments];
        newList[editingIndex] = updatedPayment;
        setListPayments(newList);
        if (setPayments) setPayments(newList);
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: nuevoPago()}));
    }

    const eliminarPayment = (index) => {
        var newList = listPayments.filter((_, i) => i !== index);
        setListPayments(newList);
        if (setPayments) setPayments(newList);

        if (editingIndex === index) {
            setEditingIndex(-1);
            dispatch(setEntity({sliceKey: sliceKey, data: nuevoPago()}));
        }
    }

    const handleDeletePayment = (index) => {
        if (esPagoRegistrado(listPayments[index])) return;

        if (esNuevo) {
            eliminarPayment(index);
            return;
        }

        setSelectIndexDelete(index);
        openCloseDialogDelete();
    }

    const handleCancelEdit = () => {
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: nuevoPago()}));
    }

    const setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}))
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Pagos del Comprobante
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={2}>
                    <FormControl required fullWidth error={validate?.idMedioPago && validation.idMedioPago.error}>
                        <InputLabel htmlFor="input-mediopago">Medio de Pago</InputLabel>
                        <Select
                            native
                            label="Medio de Pago"
                            value={entity?.idMedioPago || 0}
                            onChange={(event) => {
                                const medio = listMedioPago?.find((row) => row.id == event.target.value);

                                dispatch(setData({sliceKey: sliceKey, name: "idMedioPago", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "medioPago", value: medio?.descripcion || ""}))
                            }}
                            inputProps={{ name: 'idMedioPago', id: 'input-mediopago' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listMedioPago?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idMedioPago && validation.idMedioPago.error ? validation.idMedioPago.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-entidadpago">Entidad</InputLabel>
                        <Select
                            native
                            label="Entidad"
                            value={entity?.idEntidadPago || 0}
                            onChange={(event) => {
                                const entidad = listEntidadPago?.find((row) => row.id == event.target.value);

                                dispatch(setData({sliceKey: sliceKey, name: "idEntidadPago", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "entidadPago", value: entidad?.descripcion || ""}))
                            }}
                            inputProps={{ name: 'idEntidadPago', id: 'input-entidadpago' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEntidadPago?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        name="numeroOperacion"
                        label="N. Operacion"
                        fullWidth
                        value={entity?.numeroOperacion || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        name="numeroVoucher"
                        label="N. Voucher"
                        fullWidth
                        value={entity?.numeroVoucher || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        type="date"
                        name="fechaPago"
                        label="Fecha de Pago"
                        fullWidth
                        value={moment(entity?.fechaPago).format('yyyy-MM-DD')}
                        onChange={setDataEntity}
                        error={validate?.fechaPago && validation.fechaPago.error}
                        helperText={validate?.fechaPago && validation.fechaPago.error ? validation.fechaPago.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                {/* La moneda y el tipo de cambio los hereda el pago del comprobante. */}
                {/* Salto de linea sin alto: el monto y los botones van en la segunda fila,
                asi la etiqueta del monto se ve completa. */}
                <Grid item xs={12} sx={{ height: 0 }} />
                <Grid item xs={6} sm={2}>
                    <TextField
                        type="number"
                        name="monto"
                        label="Monto"
                        fullWidth
                        value={entity?.monto ?? ""}
                        onChange={setDataEntity}
                        error={validate?.monto && validation.monto.error}
                        helperText={validate?.monto && validation.monto.error ? validation.monto.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        inputProps={{ step: 0.01, min: 0 }}
                    />
                </Grid>
                <Grid item xs={6} sm={4}>
                    <Box display="flex" alignItems="center" gap={1}>
                        {editingIndex >= 0 ? (
                            <>
                                <Button variant="contained" size="small" onClick={handleUpdatePayment} disabled={isReadOnly}>Actualizar</Button>
                                <Button variant="outlined" size="small" onClick={handleCancelEdit}>Cancelar</Button>
                            </>
                        ) : (
                            <Button variant="contained" size="small" onClick={handleAddPayment} startIcon={<IconAdd />} disabled={isReadOnly}>Agregar</Button>
                        )}
                    </Box>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>N°</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Medio de Pago</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Entidad</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>N. Operacion</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Monto</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listPayments.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{index + 1}</TableCell>
                                    <TableCell>{row.medioPago}</TableCell>
                                    <TableCell>{row.entidadPago}</TableCell>
                                    <TableCell>{row.numeroOperacion}</TableCell>
                                    <TableCell align="center">{moment(row.fechaPago).format('DD/MM/YYYY')}</TableCell>
                                    <TableCell align="right">{(parseFloat(row.monto) || 0).toFixed(2)}</TableCell>
                                    <TableCell align="center">
                                        {/* Los pagos ya registrados solo muestran su estado. */}
                                        {esPagoRegistrado(row)
                                            ? <Typography variant="body2">{estadoPagoDescripcion(row)}</Typography>
                                            : <>
                                                <IconButton size="small" disabled={isReadOnly} onClick={() => handleEditPayment(index)}>
                                                    <IconEdit fontSize="small" />
                                                </IconButton>
                                                <IconButton size="small" disabled={isReadOnly} onClick={() => handleDeletePayment(index)}>
                                                    <IconDelete fontSize="small" />
                                                </IconButton>
                                            </>
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                            {listPayments.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <Typography variant="body2" color="textSecondary">
                                            No hay pagos registrados
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={() => eliminarPayment(selectIndexDelete)}
                setNo={() => { return }}
                titulo={"Borrar Pago"}
                texto={"Esta seguro de borrar el pago del comprobante?"}
            ></DialogYesNo>
        </Grid>
    )
}
export default ReceiptPayment;